import axiosInstance from "../../../utils/axios";

const path = "doctor/auth"

export const doctorLogin = async (values) => {
    return await axiosInstance().post(`${path}/login`, values);
}

export const DoctorForgetPassword = async (values) => {
    return await axiosInstance().post(`${path}/forget-password`, values);
}

export const DoctorOtpVerification = async (values) => {
    return await axiosInstance().post(`${path}/verify-otp`, values);
}

export const DoctorResetPassword = async (values) => {
    return await axiosInstance().patch(`${path}/reset-password`, values);
}

export const DoctorResendOtp = async (values) => {
    return await axiosInstance().post(`${path}/resend-otp`, values);
}
